
  (() => {
    const init = () => {
    const money = (cents, currency) => new Intl.NumberFormat(
      document.documentElement.lang || 'de-DE',
      { style: 'currency', currency: currency || 'EUR' }
    ).format((Number(cents) || 0) / 100);

    document.querySelectorAll('[data-mp-anchor-link]').forEach((link) => {
      if (link.dataset.mpAnchorReady === 'true') return;
      link.dataset.mpAnchorReady = 'true';
      link.addEventListener('click', (event) => {
        const targetId = link.getAttribute('href');
        if (!targetId || targetId.charAt(0) !== '#') return;
        const target = document.querySelector(targetId);
        if (!target) return;
        event.preventDefault();
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({
          behavior: reducedMotion ? 'auto' : 'smooth',
          block: 'start',
        });
        window.history.replaceState({}, '', targetId);
      });
    });

    const selectMedia = (root, mediaId) => {
      if (!mediaId) return;
      const viewportLeft = window.scrollX;
      const viewportTop = window.scrollY;
      const items = [...root.querySelectorAll('[data-mp-media-id]')];
      items.forEach((item) => {
        const isActive = String(item.dataset.mpMediaId) === String(mediaId);
        if (isActive) {
          const imageTemplate = item.querySelector('template[data-mp-media-image]');
          if (imageTemplate) imageTemplate.replaceWith(imageTemplate.content);
        }
        if (!isActive) item.querySelectorAll('video').forEach((video) => video.pause());
        item.hidden = !isActive;
        item.setAttribute('aria-hidden', String(!isActive));
      });
      root.querySelectorAll('[data-mp-gallery-thumb]').forEach((button) => {
        const active = String(button.dataset.mpGalleryThumb) === String(mediaId);
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
        if (active) {
          const strip = button.closest('.mp-gallery__thumbs');
          if (strip) {
            const buttonLeft = button.offsetLeft;
            const buttonRight = buttonLeft + button.offsetWidth;
            if (buttonLeft < strip.scrollLeft) strip.scrollLeft = buttonLeft;
            else if (buttonRight > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = buttonRight - strip.clientWidth;
          }
        }
      });
      const activeIndex = items.findIndex((item) => String(item.dataset.mpMediaId) === String(mediaId));
      const current = root.querySelector('[data-mp-gallery-current]');
      if (current && activeIndex >= 0) current.textContent = String(activeIndex + 1);
      root.dispatchEvent(new CustomEvent('mp:gallery-select', { detail: { mediaId: String(mediaId) } }));
      const restoreViewport = () => {
        if (window.scrollX !== viewportLeft || window.scrollY !== viewportTop) {
          window.scrollTo({ left: viewportLeft, top: viewportTop, behavior: 'instant' });
        }
      };
      restoreViewport();
      window.requestAnimationFrame(restoreViewport);
    };

    const normalizeMediaText = (value) => String(value || '')
      .toLocaleLowerCase('de-DE')
      .replace(/×/g, 'x')
      .replace(/[^a-z0-9]+/g, '');

    const resolveOptionMedia = (root, selected) => {
      const mediaItems = [...root.querySelectorAll('[data-mp-media-id]')];
      if (mediaItems.length < 2) return null;
      const values = selected.filter(Boolean);
      const joined = values.join(' | ');
      const hints = values
        .filter((value) => !/halterung|montage|kabel|stecker/i.test(value))
        .map((value) => ({ token: normalizeMediaText(value), weight: 12 }))
        .filter((hint) => hint.token.length >= 3);
      const moduleMatch = joined.match(/(\d{3,4})\s*w?\s*[x×]\s*(\d{1,2})/i)
        || joined.match(/(\d{1,2})\s*[x×]\s*(\d{3,4})\s*w/i);
      if (moduleMatch) {
        const first = Number(moduleMatch[1]);
        const second = Number(moduleMatch[2]);
        const watts = first > second ? first : second;
        const count = first > second ? second : first;
        hints.push({ token: `${watts}wx${count}`, weight: 18 });
        hints.push({ token: `${count}x${watts}w`, weight: 18 });
        hints.push({ token: `${watts * count}w`, weight: 15 });
        hints.push({ token: `${watts * count}watt`, weight: 15 });
      }
      const capacity = joined.match(/(\d+(?:[.,]\d+)?)\s*kwh/i)?.[1];
      if (capacity) hints.push({ token: `${capacity.replace(',', '')}kwh`, weight: 10 });
      const batteryCount = joined.match(/(\d+)\s*x\s*ab\s*3000/i)?.[1];
      if (batteryCount) hints.push({ token: `${batteryCount}xab3000`, weight: 10 });

      let best = { id: null, score: 0 };
      mediaItems.forEach((item) => {
        const search = normalizeMediaText(item.dataset.mpMediaSearch);
        const score = hints.reduce((total, hint) => total + (search.includes(hint.token) ? hint.weight : 0), 0);
        if (score > best.score) best = { id: item.dataset.mpMediaId, score };
      });
      if (best.id && best.score >= 10) return best.id;

      const primaryGroup = root.querySelector('[data-mp-option-position]');
      const primaryInputs = [...(primaryGroup?.querySelectorAll('input') || [])];
      const primaryIndex = primaryInputs.findIndex((input) => input.checked);
      const primaryValue = primaryInputs[primaryIndex]?.value || '';
      const primaryIsVisual = /\d+\s*w|solarmodul|speicher|batter/i.test(primaryValue)
        && !/halterung|montage|kabel|stecker/i.test(primaryValue);
      if (primaryIsVisual && primaryIndex >= 0 && primaryIndex < mediaItems.length) {
        return mediaItems[primaryIndex].dataset.mpMediaId;
      }
      return null;
    };

    const initBasicRoot = (root) => {
      if (root.dataset.mpBasicInitialized === 'true') return;
      root.dataset.mpBasicInitialized = 'true';

      const deliveryPopoverTrigger = root.querySelector('[data-mp-delivery-popover-trigger]');
      const deliveryPopover = root.querySelector('[data-mp-delivery-popover]');
      if (deliveryPopoverTrigger && deliveryPopover?.showPopover) {
        const isDeliveryPopoverOpen = () => deliveryPopover.matches(':popover-open');
        const positionDeliveryPopover = () => {
          if (!isDeliveryPopoverOpen()) return;
          const triggerRect = deliveryPopoverTrigger.getBoundingClientRect();
          const viewportWidth = document.documentElement.clientWidth;
          const margin = 8;
          const panelWidth = Math.min(352, viewportWidth - (margin * 2));
          const left = Math.min(
            Math.max(margin, triggerRect.left),
            viewportWidth - panelWidth - margin
          );
          const arrowLeft = Math.min(
            Math.max(18, (triggerRect.left + (triggerRect.width / 2)) - left - 6),
            panelWidth - 29
          );
          deliveryPopover.style.setProperty('--mp-delivery-popover-top', `${triggerRect.bottom + 7}px`);
          deliveryPopover.style.setProperty('--mp-delivery-popover-left', `${left}px`);
          deliveryPopover.style.setProperty('--mp-delivery-popover-arrow-left', `${arrowLeft}px`);
        };
        deliveryPopover.addEventListener('toggle', () => {
          const isOpen = isDeliveryPopoverOpen();
          deliveryPopoverTrigger.setAttribute('aria-expanded', String(isOpen));
          if (isOpen) positionDeliveryPopover();
        });
        window.addEventListener('scroll', positionDeliveryPopover, { passive: true });
        window.addEventListener('resize', positionDeliveryPopover, { passive: true });
      }

      const assurance = root.querySelector('[data-mp-assurance]');
      if (assurance) {
        const assuranceMobile = assurance.querySelector('[data-mp-assurance-mobile]');
        const assuranceSummary = assurance.querySelector('[data-mp-assurance-mobile-summary]');
        const assuranceMobileText = assurance.querySelector('[data-mp-assurance-mobile-text]');
        const assurancePanels = [...assurance.querySelectorAll('.mp-assurance__mobile-panel [data-mp-assurance-panel]')];
        const assuranceReady = assurancePanels.length > 0
          && assuranceMobile
          && assuranceSummary
          && assuranceMobileText;

        if (!assuranceReady) {
          console.error('[Mini Power] Product assurance requires a mobile details bar and inline panels.');
        } else {
          let assuranceIndex = 0;
          const setAssuranceIndex = (nextIndex) => {
            assuranceIndex = (Number(nextIndex) + assurancePanels.length) % assurancePanels.length;
            assuranceMobileText.textContent = assurancePanels[assuranceIndex].dataset.mpAssuranceLabel || '';
            assurancePanels.forEach((panel, index) => { panel.hidden = index !== assuranceIndex; });
          };
          setAssuranceIndex(0);

          assuranceMobile.addEventListener('toggle', () => {
            assuranceSummary.setAttribute('aria-expanded', String(assuranceMobile.open));
            if (assuranceMobile.open) setAssuranceIndex(assuranceIndex);
          });
          assuranceMobile.addEventListener('keydown', (event) => {
            if (event.key !== 'Escape' || !assuranceMobile.open) return;
            assuranceMobile.open = false;
            assuranceSummary.focus();
          });

          const assuranceRotation = window.setInterval(() => {
            if (!assurance.isConnected) {
              window.clearInterval(assuranceRotation);
              return;
            }
            if (assuranceMobile.classList.contains('is-visible') && !assuranceMobile.open) {
              setAssuranceIndex(assuranceIndex + 1);
            }
          }, 5000);

          const assuranceHeader = document.querySelector('.mp-header-section, .t4s-section-header');
          const assuranceStop = root.querySelector('.mp-anchor-nav');
          let assuranceFrame = 0;
          const syncAssuranceMobile = () => {
            const mobileViewport = window.matchMedia('(max-width: 989px)').matches;
            const rootRect = root.getBoundingClientRect();
            const headerRect = assuranceHeader?.getBoundingClientRect();
            const stopRect = assuranceStop?.getBoundingClientRect();
            const topOffset = Math.max(0, Math.ceil(headerRect?.bottom || 0));
            const barHeight = assuranceSummary.offsetHeight || 36;
            const threshold = Math.max(120, Math.round(window.innerHeight * .18));
            const beforeNextSticky = !stopRect || stopRect.top > topOffset + barHeight;
            const visible = mobileViewport
              && rootRect.top < -threshold
              && rootRect.bottom > topOffset + barHeight + 24
              && beforeNextSticky;
            assuranceMobile.style.setProperty('--mp-assurance-top', String(topOffset) + 'px');
            assuranceMobile.classList.toggle('is-visible', visible);
            assuranceMobile.setAttribute('aria-hidden', String(!visible));
            assuranceSummary.tabIndex = visible ? 0 : -1;
            if (!visible && assuranceMobile.open) assuranceMobile.open = false;
          };
          const scheduleAssuranceMobile = () => {
            window.cancelAnimationFrame(assuranceFrame);
            assuranceFrame = window.requestAnimationFrame(syncAssuranceMobile);
          };
          window.addEventListener('scroll', scheduleAssuranceMobile, { passive: true });
          window.addEventListener('resize', scheduleAssuranceMobile, { passive: true });
          scheduleAssuranceMobile();
        }
      }

      const anchorNav = root.querySelector('.mp-anchor-nav');
      if (anchorNav) {
        const placeholder = document.createElement('div');
        placeholder.className = 'mp-anchor-nav-placeholder';
        placeholder.setAttribute('aria-hidden', 'true');
        anchorNav.before(placeholder);
        anchorNav.classList.add('is-scroll-managed');
        const anchorTargets = [...anchorNav.querySelectorAll('[data-mp-anchor-link]')]
          .map((link) => {
            const selector = link.getAttribute('href');
            const target = selector?.startsWith('#') ? document.getElementById(selector.slice(1)) : null;
            link.hidden = !target;
            return target;
          })
          .filter(Boolean);
        const stickyHeader = document.querySelector('.mp-header-section, .t4s-section-header');
        let anchorFrame;
        const syncAnchorNav = () => {
          const navHeight = Math.ceil(anchorNav.getBoundingClientRect().height);
          const headerRect = stickyHeader?.getBoundingClientRect();
          const headerBottom = headerRect?.bottom || 0;
          const topOffset = Math.max(0, Math.ceil(headerBottom));
          const reservedHeaderOffset = Math.max(topOffset, Math.min(64, Math.ceil(headerRect?.height || 0)));
          const start = placeholder.getBoundingClientRect().top + window.scrollY;
          const end = anchorTargets.reduce((maximum, target) => (
            Math.max(maximum, target.getBoundingClientRect().bottom + window.scrollY)
          ), start);
          const fixed = anchorTargets.length > 0
            && window.scrollY + topOffset >= start
            && window.scrollY + topOffset + navHeight < end;
          anchorNav.style.setProperty('--mp-anchor-top', `${topOffset}px`);
          anchorTargets.forEach((target) => {
            target.style.scrollMarginTop = `${reservedHeaderOffset + navHeight + 12}px`;
          });
          anchorNav.classList.toggle('is-fixed', fixed);
          placeholder.style.height = fixed ? `${navHeight}px` : '0px';
        };
        const scheduleAnchorNav = () => {
          window.cancelAnimationFrame(anchorFrame);
          anchorFrame = window.requestAnimationFrame(syncAnchorNav);
        };
        window.addEventListener('scroll', scheduleAnchorNav, { passive: true });
        window.addEventListener('resize', scheduleAnchorNav, { passive: true });
        root.mpSyncAnchorNav = scheduleAnchorNav;
        scheduleAnchorNav();
      }

      const gallery = root.querySelector('[data-mp-gallery]');
      const getMediaItems = () => [...root.querySelectorAll('[data-mp-media-id]')];
      const moveMedia = (delta) => {
        const mediaItems = getMediaItems();
        if (mediaItems.length < 2) return;
        const currentIndex = mediaItems.findIndex((item) => item.getAttribute('aria-hidden') !== 'true');
        const nextIndex = (Math.max(currentIndex, 0) + delta + mediaItems.length) % mediaItems.length;
        selectMedia(root, mediaItems[nextIndex].dataset.mpMediaId);
      };
      root.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const thumb = event.target.closest('[data-mp-gallery-thumb]');
        if (thumb && root.contains(thumb)) {
          selectMedia(root, thumb.dataset.mpGalleryThumb);
          return;
        }

        const previous = event.target.closest('[data-mp-gallery-previous]');
        const next = event.target.closest('[data-mp-gallery-next]');
        if (!previous && !next) return;
        event.preventDefault();
        moveMedia(previous ? -1 : 1);
      });
      gallery?.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        if (event.target.closest('input, textarea, select, video, model-viewer')) return;
        event.preventDefault();
        moveMedia(event.key === 'ArrowLeft' ? -1 : 1);
      });
      const initiallyVisibleMedia = getMediaItems().find((item) => !item.hidden);
      if (initiallyVisibleMedia) selectMedia(root, initiallyVisibleMedia.dataset.mpMediaId);

      const stickyStage = root.querySelector('[data-mp-media-sticky-stage]');
      const stickyStop = root.querySelector('[data-mp-gallery-sticky-stop]');
      const syncMediaStickyStage = () => {
        if (!stickyStage) return;
        if (!window.matchMedia('(min-width: 990px)').matches || !gallery || !stickyStop) {
          stickyStage.style.removeProperty('height');
          return;
        }
        const stageRect = stickyStage.getBoundingClientRect();
        const stopRect = stickyStop.getBoundingClientRect();
        // Storefront zoom scales viewport measurements, but style.height uses CSS pixels.
        const stageScale = stageRect.width / stickyStage.offsetWidth || 1;
        const galleryHeight = Math.ceil(gallery.getBoundingClientRect().height / stageScale);
        const stopOffset = Math.ceil((stopRect.top - stageRect.top) / stageScale);
        stickyStage.style.height = `${Math.max(galleryHeight, stopOffset)}px`;
      };
      let stickyStageFrame;
      const scheduleMediaStickyStage = () => {
        window.cancelAnimationFrame(stickyStageFrame);
        stickyStageFrame = window.requestAnimationFrame(syncMediaStickyStage);
      };
      root.mpSyncMediaStickyStage = scheduleMediaStickyStage;
      root.querySelectorAll('[data-mp-gallery] img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', scheduleMediaStickyStage, { once: true });
      });
      window.addEventListener('resize', scheduleMediaStickyStage, { passive: true });
      if ('ResizeObserver' in window) {
        const stickyStageObserver = new ResizeObserver(scheduleMediaStickyStage);
        stickyStageObserver.observe(gallery);
        stickyStageObserver.observe(stickyStop);
        root.mpStickyStageObserver = stickyStageObserver;
      }
      scheduleMediaStickyStage();

      const quickPanel = root.querySelector('[data-mp-quick-panel]');
      if (quickPanel) {
        const tablist = quickPanel.querySelector('.mp-quick-tabs');
        const tabs = [...quickPanel.querySelectorAll('[data-mp-quick-tab]')];
        const panes = [...quickPanel.querySelectorAll('[data-mp-quick-pane]')];
        const indicator = quickPanel.querySelector('[data-mp-quick-indicator]');
        const more = quickPanel.querySelector('[data-mp-quick-more]');
        const quickBuybox = root.querySelector('[data-mp-buybox]');
        let quickPaneFrame = 0;
        const syncQuickIndicator = () => {
          const activeTab = tabs.find((tab) => tab.classList.contains('is-active'));
          if (!indicator || !tablist || !activeTab) return;
          const tabRect = activeTab.getBoundingClientRect();
          const listRect = tablist.getBoundingClientRect();
          const scale = tablist.offsetWidth ? listRect.width / tablist.offsetWidth : 1;
          indicator.style.width = `${tabRect.width / scale}px`;
          indicator.style.transform = `translate3d(${(tabRect.left - listRect.left) / scale}px, 0, 0)`;
        };
        const syncQuickMore = () => {
          if (!more) return;
          const activePane = panes.find((pane) => !pane.hidden);
          if (!activePane) {
            more.hidden = true;
            return;
          }
          if (window.matchMedia('(min-width: 990px)').matches && quickBuybox) {
            const moreStyle = getComputedStyle(more);
            const moreHeight = more.getBoundingClientRect().height || parseFloat(moreStyle.minHeight) || 48;
            const footerHeight = moreHeight + (parseFloat(moreStyle.marginTop) || 0) + (parseFloat(moreStyle.marginBottom) || 0);
            const availableHeight = Math.max(0, Math.floor(quickBuybox.getBoundingClientRect().bottom - activePane.getBoundingClientRect().top - footerHeight));
            const heightValue = `${availableHeight}px`;
            if (activePane.style.getPropertyValue('--mp-quick-collapsed-height') !== heightValue) {
              activePane.style.setProperty('--mp-quick-collapsed-height', heightValue);
            }
          } else activePane.style.removeProperty('--mp-quick-collapsed-height');
          const configuredHeight = parseFloat(getComputedStyle(activePane).getPropertyValue('--mp-quick-collapsed-height'));
          const collapsedHeight = Number.isFinite(configuredHeight) ? configuredHeight : 420;
          const needsCollapse = activePane.scrollHeight > collapsedHeight + 1;
          activePane.dataset.mpQuickCollapsible = String(needsCollapse);
          more.hidden = !needsCollapse;
          if (!needsCollapse) {
            quickPanel.classList.remove('is-expanded');
            more.setAttribute('aria-expanded', 'false');
            more.textContent = more.dataset.moreLabel;
          }
        };
        const activateQuickTab = (index, moveFocus = false) => {
          const normalized = (index + tabs.length) % tabs.length;
          quickPanel.classList.remove('is-expanded');
          more?.setAttribute('aria-expanded', 'false');
          if (more) more.textContent = more.dataset.moreLabel;
          tabs.forEach((tab, tabIndex) => {
            const active = tabIndex === normalized;
            tab.classList.toggle('is-active', active);
            tab.setAttribute('aria-selected', String(active));
            tab.tabIndex = active ? 0 : -1;
          });
          window.cancelAnimationFrame(quickPaneFrame);
          panes.forEach((pane, paneIndex) => {
            pane.hidden = paneIndex !== normalized;
            pane.classList.remove('is-active');
          });
          syncQuickIndicator();
          quickPaneFrame = window.requestAnimationFrame(() => {
            panes[normalized]?.classList.add('is-active');
            syncQuickMore();
          });
          if (more && panes[normalized]) more.setAttribute('aria-controls', panes[normalized].id);
          if (moveFocus) tabs[normalized]?.focus();
        };
        tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => activateQuickTab(index));
          tab.addEventListener('keydown', (event) => {
            let next = null;
            if (event.key === 'ArrowRight') next = index + 1;
            if (event.key === 'ArrowLeft') next = index - 1;
            if (event.key === 'Home') next = 0;
            if (event.key === 'End') next = tabs.length - 1;
            if (next == null) return;
            event.preventDefault();
            activateQuickTab(next, true);
          });
        });
        more?.addEventListener('click', () => {
          const expanded = more.getAttribute('aria-expanded') === 'true';
          quickPanel.classList.toggle('is-expanded', !expanded);
          more.setAttribute('aria-expanded', String(!expanded));
          more.textContent = expanded ? more.dataset.moreLabel : more.dataset.lessLabel;
          if (expanded) more.scrollIntoView({ block: 'nearest' });
        });
        // Keyboard focus must reveal any controls outside the collapsed preview.
        quickPanel.addEventListener('focusin', (event) => {
          const pane = event.target.closest('[data-mp-quick-pane]');
          if (!pane || quickPanel.classList.contains('is-expanded')) return;
          if (pane.scrollTop > 0 || event.target.getBoundingClientRect().bottom > pane.getBoundingClientRect().bottom) {
            quickPanel.classList.add('is-expanded');
            more?.setAttribute('aria-expanded', 'true');
            if (more) more.textContent = more.dataset.lessLabel;
            pane.scrollTop = 0;
          }
        });
        activateQuickTab(Math.max(0, tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true')));
        window.addEventListener('resize', () => {
          syncQuickIndicator();
          syncQuickMore();
        }, { passive: true });
        if ('ResizeObserver' in window && tablist) {
          const quickTabsObserver = new ResizeObserver(() => {
            syncQuickIndicator();
            syncQuickMore();
          });
          quickTabsObserver.observe(tablist);
          if (quickBuybox) quickTabsObserver.observe(quickBuybox);
          if (stickyStage) quickTabsObserver.observe(stickyStage);
          panes.forEach((pane) => quickTabsObserver.observe(pane));
          root.mpQuickTabsObserver = quickTabsObserver;
        }
      }

      const toggle = root.querySelector('[data-mp-collapsible-toggle]');
      const content = root.querySelector('[data-mp-collapsible-content]');
      if (toggle && content) {
        content.classList.add('is-collapsible-ready');
        const syncCollapsible = () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          const isMobile = window.matchMedia('(max-width: 749px)').matches;
          const collapsedHeight = isMobile ? 400 : 350;
          content.style.setProperty('--mp-description-collapsed-height', `${collapsedHeight}px`);
          content.classList.remove('is-not-collapsible');
          const needsCollapse = content.scrollHeight > collapsedHeight + 1;
          toggle.hidden = !needsCollapse;
          content.classList.toggle('is-not-collapsible', !needsCollapse);
          if (!needsCollapse && expanded) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.textContent = toggle.dataset.moreLabel;
            content.classList.remove('is-expanded');
          }
        };
        toggle.addEventListener('click', () => {
          const expanded = toggle.getAttribute('aria-expanded') === 'true';
          toggle.setAttribute('aria-expanded', String(!expanded));
          toggle.textContent = expanded ? toggle.dataset.moreLabel : toggle.dataset.lessLabel;
          content.classList.toggle('is-expanded', !expanded);
          syncCollapsible();
        });
        syncCollapsible();
        let resizeFrame;
        window.addEventListener('resize', () => {
          window.cancelAnimationFrame(resizeFrame);
          resizeFrame = window.requestAnimationFrame(syncCollapsible);
        }, { passive: true });
      }
    };

    const initRoot = (root) => {
      initBasicRoot(root);
      if (root.dataset.mpVariantInitialized === 'true') return;
      const buybox = root.querySelector('[data-mp-buybox]');
      const data = buybox?.querySelector('[data-mp-product-variants]');
      let optionSelectionChanged = false;
      const getProductForms = () => [...root.querySelectorAll('.mp-product-form')];
      const getVariantIdInputs = () => getProductForms().map((form) => form.querySelector('[data-mp-variant-id]')).filter(Boolean);
      const getQuantityInputs = () => getProductForms().map((form) => form.querySelector('[data-mp-quantity-input]')).filter(Boolean);
      const getAddButtons = () => getProductForms().flatMap((form) => [...form.querySelectorAll('[data-mp-add]')]);
      const getPurchaseGates = () => getProductForms().map((form) => form.querySelector('[data-mp-purchase-gate]')).filter(Boolean);
      const dynamicCheckouts = [...root.querySelectorAll('[data-mp-dynamic-checkout]')];
      const failClosed = () => {
        getVariantIdInputs().forEach((input) => {
          input.value = '';
          input.disabled = true;
        });
        getPurchaseGates().forEach((gate) => {
          gate.disabled = true;
          gate.setAttribute('aria-disabled', 'true');
        });
        getAddButtons().forEach((button) => { button.disabled = true; });
        dynamicCheckouts.forEach((checkout) => {
          checkout.hidden = true;
          checkout.inert = true;
          checkout.setAttribute('aria-hidden', 'true');
        });
      };
      if (!buybox || !data) {
        failClosed();
        return;
      }

      let variants = [];
      try {
        variants = JSON.parse(data.textContent);
      } catch (error) {
        failClosed();
        return;
      }
      const productStaticNode = buybox.querySelector('[data-mp-product-static]');
      let productStatic = { key_stats: [], specifications: [] };
      try {
        const parsedProductStatic = JSON.parse(productStaticNode?.textContent || '{}');
        if (parsedProductStatic && typeof parsedProductStatic === 'object') {
          productStatic = {
            key_stats: Array.isArray(parsedProductStatic.key_stats) ? parsedProductStatic.key_stats : [],
            specifications: Array.isArray(parsedProductStatic.specifications) ? parsedProductStatic.specifications : [],
          };
        }
      } catch (error) {
        console.error('[Mini Power Product] Static product data could not be read.', error);
      }
      const highlightFacts = root.querySelector('[data-mp-highlight-facts]');
      const highlightSourceNode = root.querySelector('[data-mp-highlight-source]');
      let highlightSources = [];
      try {
        const parsedHighlightSources = JSON.parse(highlightSourceNode?.textContent || '[]');
        if (Array.isArray(parsedHighlightSources)) {
          highlightSources = parsedHighlightSources
            .map((source) => ({
              title: String(source?.title || '').trim(),
              body: String(source?.body || '').replace(/\s+/g, ' ').trim(),
            }))
            .filter((source) => source.title || source.body);
        }
      } catch (error) {
        console.error('[Mini Power Product] Highlight source data could not be read.', error);
      }
      const shippingClassificationNode = buybox.querySelector('[data-mp-shipping-classifications]');
      let shippingClassifications = {};
      try {
        const parsed = JSON.parse(shippingClassificationNode?.textContent || '{}');
        if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) shippingClassifications = parsed;
      } catch (error) {
        console.error('[Mini Power Shipping] Product classification data could not be read.', error);
      }
      const expectedVariantCount = Number(buybox.dataset.mpExpectedVariantCount);
      if (!Number.isInteger(expectedVariantCount) || expectedVariantCount < 1 || variants.length !== expectedVariantCount) {
        failClosed();
        return;
      }

      const variantState = window.MPProductVariantState;
      if (!variantState) {
        failClosed();
        return;
      }
      root.dataset.mpVariantInitialized = 'true';

      let activeVariant = null;
      let activePurchaseAvailability = 'unavailable';
      const syncQuantityInputs = (source) => {
        getQuantityInputs().forEach((input) => {
          if (input !== source) input.value = source.value;
        });
        syncQuantityButtons();
        if (activeVariant) renderShippingContext(activeVariant, activePurchaseAvailability);
      };
      const syncQuantityButtons = () => {
        root.querySelectorAll('.mp-quantity').forEach((stepper) => {
          const input = stepper.querySelector('[data-mp-quantity-input]');
          const decrease = stepper.querySelector('[data-mp-quantity-decrease]');
          const increase = stepper.querySelector('[data-mp-quantity-increase]');
          if (!input) return;
          const value = Number(input.value);
          const minimum = Number(input.min) || 1;
          const maximum = input.max === '' ? null : Number(input.max);
          if (decrease) decrease.disabled = !Number.isFinite(value) || value <= minimum;
          if (increase) increase.disabled = Number.isFinite(maximum) && value >= maximum;
        });
      };
      getQuantityInputs().forEach((input) => {
        input.addEventListener('input', () => syncQuantityInputs(input));
        input.addEventListener('change', () => syncQuantityInputs(input));
      });
      root.addEventListener('click', (event) => {
        if (!(event.target instanceof Element)) return;
        const button = event.target.closest('[data-mp-quantity-decrease], [data-mp-quantity-increase]');
        if (!button || !root.contains(button) || button.disabled) return;
        const input = button.closest('.mp-quantity')?.querySelector('[data-mp-quantity-input]');
        if (!input || input.disabled) return;
        event.preventDefault();
        if (button.matches('[data-mp-quantity-decrease]')) input.stepDown();
        else input.stepUp();
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const bindSubmitGuards = (forms) => forms.forEach((form) => {
        if (form.dataset.mpSubmitGuardBound === 'true') return;
        form.dataset.mpSubmitGuardBound = 'true';
        form.addEventListener('submit', (event) => {
          const idInput = form.querySelector('[data-mp-variant-id]');
          const quantity = form.querySelector('[data-mp-quantity-input]');
          const purchaseGate = form.querySelector('[data-mp-purchase-gate]');
          const invalidQuantity = quantity && !quantity.checkValidity();
          if (form.dataset.mpPurchasable !== 'true' || purchaseGate?.disabled || !idInput || idInput.disabled || !idInput.value || invalidQuantity) {
            event.preventDefault();
            event.stopImmediatePropagation();
            if (invalidQuantity) quantity.reportValidity();
          }
        }, true);
      });

      const updatePurchaseControls = (variant) => {
        const state = variantState.purchaseState(variant);
        if (buybox.dataset.mpEmailOnly === 'true' || root.dataset.mpSetCheckoutBlocked === 'true') {
          state.variantInputDisabled = true;
          state.formSubmittable = false;
          state.dynamicCheckoutEnabled = false;
        }
        const productForms = getProductForms();
        const addButtons = getAddButtons();
        const purchaseGates = getPurchaseGates();
        bindSubmitGuards(productForms);
        getVariantIdInputs().forEach((input) => {
          input.value = state.variantId;
          input.disabled = state.variantInputDisabled;
        });
        productForms.forEach((form) => {
          form.dataset.mpVariantState = state.availability;
          form.dataset.mpPurchasable = String(state.formSubmittable);
          form.removeAttribute('aria-disabled');
        });
        purchaseGates.forEach((gate) => {
          gate.disabled = !state.formSubmittable;
          gate.setAttribute('aria-disabled', String(!state.formSubmittable));
        });
        dynamicCheckouts.forEach((checkout) => {
          checkout.dataset.mpCheckoutEnabled = String(state.dynamicCheckoutEnabled);
          checkout.hidden = !state.dynamicCheckoutEnabled;
          checkout.inert = !state.dynamicCheckoutEnabled;
          checkout.setAttribute('aria-hidden', String(!state.dynamicCheckoutEnabled));
        });
        addButtons.forEach((button) => {
          button.disabled = !state.formSubmittable;
          if (state.formSubmittable) button.removeAttribute('aria-disabled');
          else button.setAttribute('aria-disabled', 'true');
          if (button.matches('[data-mp-action-atc]')) button.dataset.variantId = state.variantId;
        });
        buybox.dataset.mpVariantAvailability = state.availability;
        return state;
      };

      const notifyVariantInputs = () => {
        getVariantIdInputs().forEach((input) => input.dispatchEvent(new Event('change', { bubbles: true })));
      };

      const updateOptionPrices = () => {
        if (!root.querySelector('.mp-options--priced')) return;
        const groups = [...root.querySelectorAll('[data-mp-option-position]')];
        const selected = groups.map((group) => group.querySelector('input:checked')?.value);
        const displayPrice = (variant) => window.MiniPowerTax?.getVariantDisplayCents?.(variant.id, variant.price) ?? variant.price;
        groups.forEach((group, optionIndex) => {
          const compatible = variants.filter((variant) => variant.options.every((value, index) => index === optionIndex || value === selected[index]));
          const prices = compatible.filter((variant) => variant.available).map(displayPrice).filter(Number.isFinite);
          const baseline = prices.length ? Math.min(...prices) : null;
          group.querySelectorAll('input').forEach((input) => {
            const badge = input.nextElementSibling?.querySelector('[data-mp-option-surcharge]');
            if (!badge) return;
            const matches = compatible.filter((variant) => variant.options[optionIndex] === input.value);
            const amount = matches.length === 1 ? displayPrice(matches[0]) : null;
            const difference = baseline == null || !Number.isFinite(amount) ? null : amount - baseline;
            const label = difference == null || difference === 0 ? '' : `${difference >= 0 ? '+' : '−'}${money(Math.abs(difference), buybox.dataset.currency || 'EUR')}`;
            if (badge.textContent !== label) badge.textContent = label;
            badge.hidden = difference == null || difference === 0;
            const state = input.dataset.mpOptionState;
            const availability = state === 'sold_out' ? buybox.dataset.soldoutLabel : state === 'unavailable' ? buybox.dataset.unavailableLabel : '';
            input.setAttribute('aria-label', [input.value, label, availability].filter(Boolean).join(' — '));
          });
        });
      };

      const updateOptionStates = (selected) => {
        root.querySelectorAll('[data-mp-option-position]').forEach((group, optionIndex) => {
          group.querySelectorAll('input').forEach((input) => {
            const state = variantState.optionValueState(variants, selected, optionIndex, input.value);
            input.dataset.mpOptionState = state;
            input.disabled = false;
            input.removeAttribute('aria-disabled');
            input.setAttribute(
              'aria-label',
              state === 'available'
                ? input.value
                : `${input.value} — ${state === 'sold_out' ? buybox.dataset.soldoutLabel : buybox.dataset.unavailableLabel}`
            );
          });
        });
      };

      const shippingDelivery = window.MPSmartShippingDelivery;
      const selectedQuantity = () => Math.max(1, Number.parseInt(getQuantityInputs()[0]?.value || '1', 10) || 1);
      const unavailableShipping = (reason, note = '') => ({
        status: 'unavailable',
        reason,
        mode: '',
        minDays: null,
        maxDays: null,
        availableFrom: '',
        note,
        amountCents: null,
        requiresSpedition: false,
      });
      const resolveShipping = (variant) => {
        if (!shippingDelivery) return unavailableShipping('delivery_resolver_unavailable');
        const shipping = variant?.shipping || {};
        const result = shippingDelivery.quote({
          variant,
          classifications: shippingClassifications,
          country: buybox.dataset.deliveryCountry || 'DE',
          quantity: selectedQuantity(),
        });
        return {
          ...result,
          note: result.mode === 'fallback' && result.sourceMode === 'preorder' ? '' : (shipping.note || buybox.dataset.shippingNote || ''),
        };
      };

      const formatShippingDate = (value) => {
        if (!value) return '';
        const date = new Date(`${value}T12:00:00`);
        if (Number.isNaN(date.getTime())) return value;
        return new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          timeZone: 'UTC',
        }).format(date);
      };

      const cleanTaxBaseCopy = (value) => String(value || '')
        .replace(/\s*·\s*(?:Versand- und Steuerdetails|Shipping and tax details)\s*$/i, '')
        .replace(/\s*·\s*(?:Kostenloser(?: Speditions)?versand|Versand(?:kosten)?[^·]*|Free(?: freight)? shipping|Shipping[^·]*)(?:\s*·\s*Details)?\s*$/i, '')
        .trim();
      const renderShippingPrice = (shipping, purchaseAvailability) => {
        const summary = root.querySelector('[data-mp-tax-legal-copy]');
        const priceDetail = root.querySelector('[data-mp-shipping-price-detail]');
        const methodDetail = root.querySelector('[data-mp-shipping-method-detail]');
        const isAvailable = purchaseAvailability === 'available' && shipping.status === 'ok';
        let shippingCopy = buybox.dataset.shippingCheckoutLabel;
        if (isAvailable && shipping.amountCents === 0) {
          shippingCopy = shipping.requiresSpedition
            ? buybox.dataset.shippingFreeFreightLabel
            : buybox.dataset.shippingFreeLabel;
        } else if (isAvailable && Number.isFinite(shipping.amountCents)) {
          shippingCopy = buybox.dataset.shippingPriceTemplate.replace(
            '__PRICE__',
            money(shipping.amountCents, 'EUR')
          );
        }

        if (summary) {
          summary.dataset.mpShippingCopy = shippingCopy;
          const taxBase = cleanTaxBaseCopy(summary.dataset.mpTaxBaseCopy || summary.textContent);
          const compact = Boolean(summary.closest('.mp-delivery-summary'));
          const shownTax = compact ? taxBase.replace('0 % MwSt. in Deutschland bei erfüllten Voraussetzungen', '0 % MwSt. in DE bei Berechtigung') : taxBase;
          const shownShipping = compact ? shippingCopy.replace('Kostenloser Speditionsversand', 'Kostenloser Versand') : shippingCopy;
          summary.textContent = [shownTax, shownShipping, compact ? '' : buybox.dataset.shippingDetailsLabel].filter(Boolean).join(' · ');
        }
        if (priceDetail) priceDetail.textContent = `${shippingCopy}.`;
        if (methodDetail) {
          const method = shipping.requiresSpedition
            ? buybox.dataset.shippingMethodFreight
            : buybox.dataset.shippingMethodStandard;
          methodDetail.textContent = isAvailable
            ? `${(document.documentElement.lang || '').toLowerCase().startsWith('de') ? 'Versandart' : 'Method'}: ${method}.`
            : '';
        }
      };

      const renderShippingContext = (variant, purchaseAvailability) => {
        const container = root.querySelector('[data-mp-shipping-context]');
        const fast = root.querySelector('[data-mp-fast-shipping]');
        const fastText = root.querySelector('[data-mp-fast-shipping-text]');
        const deliveryPopover = root.querySelector('[data-mp-delivery-popover]');
        const deliveryPopoverTitle = root.querySelector('[data-mp-delivery-popover-title]');
        const deliveryPopoverCopy = root.querySelector('[data-mp-delivery-popover-copy]');
        const shipping = resolveShipping(variant);
        renderShippingPrice(shipping, purchaseAvailability);
        let shortMessage = '';
        let detailMessage = '';
        if (shipping.mode === 'preorder' && shipping.availableFrom && !shipping.minDays) {
          if (shipping.availableFrom) {
            const date = formatShippingDate(shipping.availableFrom);
            shortMessage = buybox.dataset.shippingPreorderTemplate.replace('__DATE__', date);
          } else {
            shortMessage = buybox.dataset.shippingPreorderPendingTemplate;
          }
          detailMessage = shortMessage;
        } else if (shipping.minDays && shipping.maxDays) {
          if (shipping.minDays === shipping.maxDays) {
            shortMessage = buybox.dataset.shippingDaysSingleTemplate.replace('__DAYS__', String(shipping.minDays));
            detailMessage = buybox.dataset.shippingDetailSingleTemplate.replace('__DAYS__', String(shipping.minDays));
          } else {
            shortMessage = buybox.dataset.shippingDaysRangeTemplate
              .replace('__MIN__', String(shipping.minDays))
              .replace('__MAX__', String(shipping.maxDays));
            detailMessage = buybox.dataset.shippingDetailRangeTemplate
              .replace('__MIN__', String(shipping.minDays))
              .replace('__MAX__', String(shipping.maxDays));
          }
          // The Smart Shipping contract guarantees a business-day range, not a same-day dispatch cutoff.
          // Keep the customer-facing estimate on that verified range instead of inventing calendar arrival dates.
        } else if (shipping.note) {
          shortMessage = shipping.note;
          detailMessage = shipping.note;
        }
        if (shipping.note && detailMessage && detailMessage !== shipping.note) detailMessage = `${detailMessage} ${shipping.note}`;
        if (shipping.status === 'ok' && shippingDelivery?.serviceName) {
          shortMessage = shippingDelivery.serviceName(shipping, {
            available: purchaseAvailability === 'available' || shipping.mode === 'preorder',
          });
          detailMessage = shortMessage;
        }
        const estimateVisible = shipping.status === 'ok'
          && Boolean(shortMessage);
        const fastMessage = buybox.dataset.mpEmailOnly === 'true'
          ? buybox.dataset.prelaunchLabel
          : estimateVisible ? shortMessage : buybox.dataset.shippingUnavailableLabel;
        const fastVisible = Boolean(fastMessage);
        if (fast) fast.hidden = !fastVisible;
        if (fastText) {
          if (fastText.closest('.mp-delivery-summary')) {
            const compactMessage = fastMessage.replace(/^Standard Spedition\b/, 'Spedition')
              .replace(/\(\s+/g, '(').replace(/\s+\)/g, ')').replace(/(\d)\s*-\s*(\d)/g, '$1–$2');
            const duration = compactMessage.match(/\b\d+(?:\s*[–-]\s*\d+)?\s*(?:Werktag(?:e|en)?|business days?)\b/i);
            if (duration) {
              const emphasis = document.createElement('strong');
              emphasis.className = 'mp-delivery-summary__duration';
              emphasis.textContent = duration[0];
              fastText.replaceChildren(compactMessage.slice(0, duration.index), emphasis, compactMessage.slice(duration.index + duration[0].length));
            } else {
              fastText.textContent = compactMessage;
            }
          } else {
            fastText.textContent = fastMessage;
          }
        }
        if (deliveryPopoverTitle) deliveryPopoverTitle.textContent = fastMessage;
        if (deliveryPopoverCopy) {
          const isGerman = (document.documentElement.lang || '').toLowerCase().startsWith('de');
          if (buybox.dataset.mpEmailOnly === 'true') {
            deliveryPopoverCopy.textContent = buybox.dataset.shippingNote;
          } else if (!estimateVisible) {
            deliveryPopoverCopy.textContent = isGerman
              ? 'Dieser Artikel ist derzeit nicht verfügbar. Sobald er wieder kaufbar ist, wird hier die aktuelle Lieferzeit angezeigt.'
              : 'This item is currently unavailable. Its current delivery time will appear here once it can be purchased again.';
          } else if (shipping.mode === 'preorder') {
            deliveryPopoverCopy.textContent = isGerman
              ? 'Dies ist ein Vorbestellartikel. Maßgeblich ist der für die gewählte Variante angezeigte Versandtermin.'
              : 'This is a pre-order item. The shipping date shown for the selected variant applies.';
          } else if (shipping.requiresSpedition) {
            deliveryPopoverCopy.textContent = isGerman
              ? 'Die angegebene Lieferzeit ist eine Prognose für verfügbare Ware. Der Versand erfolgt per Spedition. Wochenenden, Feiertage und die Terminabstimmung können die Zustellung verschieben.'
              : 'The stated delivery time is an estimate for goods in stock. Shipping is by freight carrier. Weekends, public holidays and appointment coordination may affect delivery.';
          } else {
            deliveryPopoverCopy.textContent = isGerman
              ? 'Die angegebene Lieferzeit ist eine Prognose für verfügbare Ware. Der Versand erfolgt als Standardversand. Wochenenden und Feiertage können die Zustellung verschieben.'
              : 'The stated delivery time is an estimate for goods in stock. Standard shipping applies. Weekends and public holidays may affect delivery.';
          }
        }
        if (!fastVisible && deliveryPopover?.hidePopover && deliveryPopover.matches(':popover-open')) deliveryPopover.hidePopover();
        if (!container) return;
        if (purchaseAvailability !== 'available' && shipping.mode !== 'preorder') {
          container.hidden = true;
          return;
        }
        const message = container.querySelector('[data-mp-shipping-message]');
        if (message) message.textContent = detailMessage;
        container.hidden = !detailMessage;
        const deliveryDetail = root.querySelector('[data-mp-shipping-delivery-detail]');
        if (deliveryDetail) {
            if (estimateVisible) {
            const method = shipping.requiresSpedition
              ? buybox.dataset.shippingMethodFreight
              : buybox.dataset.shippingMethodStandard;
            deliveryDetail.textContent = `${shortMessage}. ${method}.`;
          } else {
            deliveryDetail.textContent = (document.documentElement.lang || '').toLowerCase().startsWith('de')
              ? 'Die verbindliche Lieferzeit für diese Auswahl wird im Checkout angezeigt.'
              : 'The binding delivery time for this selection is shown at checkout.';
          }
        }
      };

      const renderInterestForm = (variant) => {
        const container = root.querySelector('[data-mp-preorder-interest]');
        if (!container) return;
        const shipping = resolveShipping(variant);
        const visible = Boolean(variant) && (buybox.dataset.mpEmailOnly === 'true' || (shipping.status === 'ok' && shipping.mode === 'preorder'));
        container.hidden = !visible;
        container.inert = !visible;
        container.querySelectorAll('input, textarea, button').forEach((control) => { control.disabled = !visible; });
        if (!visible) return;
        const availableFrom = shipping.availableFrom || (buybox.dataset.mpEmailOnly === 'true' ? buybox.dataset.shippingAvailableFrom : '') || '';
        const formattedDate = availableFrom
          ? formatShippingDate(availableFrom)
          : ((document.documentElement.lang || '').toLowerCase().startsWith('de') ? 'Termin wird bestätigt' : 'Date to be confirmed');
        const productTitle = root.querySelector('.mp-product-title')?.textContent?.trim() || '';
        const variantTitle = variant.title || (Array.isArray(variant.options) ? variant.options.filter(Boolean).join(' · ') : '');
        const productUrl = new URL(window.location.href);
        productUrl.searchParams.set('variant', String(variant.id));
        const values = {
          '[data-mp-interest-variant-title]': variantTitle,
          '[data-mp-interest-variant-id]': String(variant.id),
          '[data-mp-interest-sku]': variant.sku || '',
          '[data-mp-interest-url]': productUrl.toString(),
          '[data-mp-interest-available-from]': availableFrom,
        };
        Object.entries(values).forEach(([selector, value]) => {
          const field = container.querySelector(selector);
          if (field) field.value = value;
        });
        const dateNode = container.querySelector('[data-mp-interest-date]');
        if (dateNode) {
          dateNode.textContent = formattedDate;
          if (availableFrom) dateNode.setAttribute('datetime', availableFrom);
          else dateNode.removeAttribute('datetime');
        }
        const message = container.querySelector('[data-mp-interest-message]');
        if (message) {
          message.value = `Produktinteresse für ${productTitle}, Variante ${variantTitle}, Variant-ID ${variant.id}, SKU ${variant.sku || ''}, verfügbar ab ${availableFrom}.`;
        }
      };

      let pickupAvailabilityVariant = null;
      const renderPickupAvailability = (variant) => {
        pickupAvailabilityVariant = variant;
        const container = root.querySelector('[data-mp-pickup-availability]');
        if (!container) return;
        const pickupPreview = root.querySelector('[data-mp-pickup-preview]');
        const pickupSelected = pickupPreview && !pickupPreview.hidden
          && pickupPreview.querySelector('[data-mp-preview-choice="pickup"][aria-pressed="true"]');
        const deliveryMode = String(variant?.shipping?.mode || '').toLowerCase();
        if (!pickupSelected || buybox.dataset.mpEmailOnly === 'true' || deliveryMode === 'preorder' || deliveryMode === 'remote') {
          container.replaceChildren();
          container.hidden = true;
          return;
        }
        const stores = Array.isArray(variant?.pickup_availabilities) ? variant.pickup_availabilities : [];
        container.replaceChildren();
        container.hidden = stores.length === 0;
        if (stores.length === 0) return;
        const heading = document.createElement('p');
        heading.textContent = container.dataset.heading;
        const list = document.createElement('ul');
        stores.forEach((store) => {
          const item = document.createElement('li');
          const name = document.createElement('strong');
          name.textContent = store.location;
          const status = store.available ? container.dataset.availableLabel : container.dataset.unavailableLabel;
          item.append(name, ` · ${status}`);
          if (store.available && store.pick_up_time) item.append(` · ${store.pick_up_time}`);
          const address = store.address || {};
          const street = [address.address1, address.address2].filter(Boolean).join(' ');
          const locality = [address.zip, address.city].filter(Boolean).join(' ');
          const addressText = [street, locality, address.country].filter(Boolean).join(' · ');
          if (addressText) {
            const addressElement = document.createElement('address');
            addressElement.className = 'mp-pickup-availability__address';
            addressElement.textContent = addressText;
            item.append(addressElement);
          }
          list.append(item);
        });
        container.append(heading, list);
      };

      root.addEventListener('mp:pickup-preview-change', () => {
        renderPickupAvailability(pickupAvailabilityVariant);
      });

      const buildPreviewBom = (selected) => {
        const joined = selected.filter(Boolean).join(' | ');
        const moduleMatch = joined.match(/500\s*W?\s*[x×]\s*(\d+)/i) || joined.match(/(\d+)\s*[x×]\s*500\s*W/i);
        const moduleCount = Number(moduleMatch?.[1]) || 4;
        const capacityMatch = joined.match(/(\d+)\s*kWh/i);
        const capacity = Number(capacityMatch?.[1]) || 5;
        const items = [
          { title: 'Anker SOLIX Solarbank 4 E5000 Pro (SKU 10004)', quantity: 1, role_label: 'Im Set enthalten' },
          { title: 'Anker SOLIX Smart Meter Gen.2 (SKU 10102)', quantity: 1, role_label: 'Im Set enthalten' },
          { title: 'Schuko/AC-Kabel 3 m (SKU 10111)', quantity: 1, role_label: 'Im Set enthalten' },
          { title: 'Jolywood JW-HD108N 500W Glas-Glas-Solarmodul (SKU 27101)', quantity: moduleCount, role_label: 'Durch Auswahl bestimmt' },
        ];
        const expansionCount = Math.max(0, Math.round((capacity - 5) / 5));
        if (expansionCount > 0) items.push({ title: 'Anker SOLIX BP5000 Erweiterungsbatterie', quantity: expansionCount, role_label: 'Aus Speicherstufe abgeleitet' });
        const mounting = selected.find((value) => value && /Halterung|Balkon|Flachdach|Ziegeldach/i.test(value));
        if (mounting && !/^ohne/i.test(mounting)) items.push({ title: `Montageart: ${mounting}`, quantity: null, role_label: 'Durch Auswahl bestimmt' });
        return items;
      };

      const normalizeBundleItems = (variant, selected) => {
        const raw = Array.isArray(variant?.bundle_items) ? variant.bundle_items : [];
        const items = raw.map((entry) => {
          if (typeof entry === 'string') return { title: entry, quantity: null, role_label: '' };
          return entry && entry.title ? entry : null;
        }).filter(Boolean);
        if (items.length === 0 && buybox.dataset.previewFixture === 'pro4_e5000') return buildPreviewBom(selected);
        return items;
      };

      const renderVariantBom = (variant, selected) => {
        const items = normalizeBundleItems(variant, selected);
        const fixtureInferred = (
          buybox.dataset.previewFixture === 'pro4_e5000'
          && (!Array.isArray(variant?.bundle_items) || variant.bundle_items.length === 0)
          && String(variant?.sku || '') !== '10851'
        );
        root.querySelectorAll('[data-mp-variant-bom]').forEach((container) => {
          const layout = container.dataset.layout || 'list';
          container.replaceChildren();
          if (container.dataset.heading) {
            const heading = document.createElement('h2');
            heading.textContent = container.dataset.heading;
            container.append(heading);
          }
          if (items.length === 0) {
            if (layout === 'cards') {
              container.hidden = true;
              return;
            }
            const empty = document.createElement('p');
            empty.className = 'mp-quick-empty';
            empty.textContent = container.dataset.emptyLabel || '';
            container.append(empty);
            container.hidden = false;
            return;
          }
          const list = document.createElement('ul');
          list.className = layout === 'cards' ? 'mp-bom-cards' : 'mp-bom-list';
          list.setAttribute('role', 'list');
          items.forEach((bundleItem) => {
            const item = document.createElement('li');
            const label = `${bundleItem.quantity ? `${bundleItem.quantity}× ` : ''}${bundleItem.title}`;
            if (layout === 'cards') {
              const strong = document.createElement('strong');
              strong.textContent = label;
              item.append(strong);
              if (bundleItem.role_label) {
                const small = document.createElement('small');
                small.textContent = bundleItem.role_label;
                item.append(small);
              }
            } else {
              item.textContent = label;
            }
            list.append(item);
          });
          container.append(list);
          if (fixtureInferred && buybox.dataset.bomPreviewNote) {
            const note = document.createElement('p');
            note.className = 'mp-bom-preview-note';
            note.textContent = buybox.dataset.bomPreviewNote;
            container.append(note);
          }
          container.hidden = false;
        });
      };

      const statGrid = root.querySelector('[data-mp-stat-grid]');
      const isPhysicalKeyStat = (stat) => {
        const label = String(stat?.label || '').trim().toLowerCase();
        const details = `${stat?.metric || ''} ${stat?.note || ''}`.trim().toLowerCase();
        const physicalLabel = /gewicht|weight|gew\.|abmess|dimension|maße|produktmaß|gerätemaß|gehäusemaß|außenmaß/i.test(label)
          || /^(maß|mass|size)$/i.test(label)
          || /product size|device size/i.test(label);
        if (physicalLabel) return true;
        const genericLabel = /^(produktdaten|technische daten|daten|wert|produktinfo|informationen)$/i.test(label);
        if (!genericLabel) return false;
        const weightValue = /(^|\s)\d+(?:[.,]\d+)?\s*(?:kg|g|lbs?)(?:$|\s)/i.test(details);
        const dimensionValue = /[x×].*(?:\smm|\scm|\sm(?:\s|$))|(?:\smm|\scm|\sm(?:\s|$)).*[x×]/i.test(details);
        return weightValue || dimensionValue;
      };
      const normalizeStatFingerprint = (value) => String(value || '')
        .normalize('NFKC')
        .trim()
        .toLocaleLowerCase('de-DE')
        .replace(/watts?/g, 'w')
        .replace(/[^\p{L}\p{N}%]+/gu, '');
      const parsePvModuleSelection = (variant, selected) => {
        const source = [...(Array.isArray(selected) ? selected : []), variant?.title]
          .filter(Boolean)
          .join(' | ');
        const wattsFirst = source.match(/(\d+(?:[.,]\d+)?)\s*w(?:p)?\s*[x×]\s*(\d+)/i);
        const countFirst = source.match(/(\d+)\s*[x×]\s*(\d+(?:[.,]\d+)?)\s*w(?:p)?/i);
        const watts = Number.parseFloat(String(wattsFirst?.[1] || countFirst?.[2] || '').replace(',', '.'));
        const count = Number.parseInt(wattsFirst?.[2] || countFirst?.[1] || '', 10);
        if (!Number.isFinite(watts) || watts <= 0 || !Number.isInteger(count) || count <= 0) return null;
        return { watts, count };
      };
      const formatVariantOption = (value) => String(value || '').trim().replace(/(\d+)\s*x\s*/i, '$1 × ');
      const adaptPvSelectionStat = (stat, pvSelection, variantSelections, hasDuplicatePvStats) => {
        if (!hasDuplicatePvStats) return stat;
        const labelKey = normalizeStatFingerprint(stat?.label);
        const noSolarModules = /ohne\s*solarmodule/i.test(variantSelections[0] || '');
        if (noSolarModules) {
          if (labelKey === 'pvmodulumfang') {
            return { ...stat, label: 'PV-Modulset', metric: 'Ohne Solarmodule' };
          }
          if (labelKey === 'pvgesamtleistung') {
            const storageSelection = /^ohne$/i.test(variantSelections[1] || '')
              ? 'Ohne Zusatzakku'
              : formatVariantOption(variantSelections[1]);
            return { ...stat, label: 'Speichererweiterung', metric: storageSelection };
          }
          if (labelKey === 'modultechnologie') {
            return { ...stat, label: 'Montagesystem', metric: formatVariantOption(variantSelections[2]) };
          }
          return stat;
        }
        if (!pvSelection) return stat;
        const watts = pvSelection.watts.toLocaleString('de-DE', { maximumFractionDigits: 2 });
        if (labelKey === 'pvmodulumfang') {
          return { ...stat, label: 'PV-Modulset', metric: `${pvSelection.count} × ${watts} W` };
        }
        if (labelKey === 'pvgesamtleistung') {
          const total = (pvSelection.count * pvSelection.watts).toLocaleString('de-DE', { maximumFractionDigits: 2 });
          return { ...stat, metric: `${total} Wp` };
        }
        return stat;
      };
      const highlightStopwords = new Set([
        'aber', 'alle', 'als', 'auch', 'auf', 'aus', 'bei', 'bis', 'das', 'dem', 'den', 'der', 'des', 'die',
        'ein', 'eine', 'einer', 'eines', 'für', 'gegen', 'im', 'in', 'ist', 'mit', 'oder', 'pro', 'und', 'von',
        'vor', 'wie', 'zu', 'zur', 'zum', 'produkt', 'system', 'angebotenen', 'ausführung',
      ]);
      const normalizeHighlightText = (value) => String(value || '')
        .normalize('NFKD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .replace(/ß/g, 'ss')
        .replace(/[^a-z0-9%]+/g, ' ')
        .trim();
      const highlightTokens = (value) => new Set(
        normalizeHighlightText(value)
          .split(/\s+/)
          .filter((token) => token.length > 2 && !highlightStopwords.has(token)),
      );
      const highlightMeasurements = (value) => new Set(
        (String(value || '').toLowerCase().match(/\d+(?:[.,]\d+)?\s*(?:kwh|wh|kwp|kw|wp|w|a|v|%|ms|m|mm|cm|jahre?|zyklen?)/g) || [])
          .map((measurement) => normalizeHighlightText(measurement).replace(/\s+/g, '')),
      );
      const highlightCategoryRules = [
        ['capacity', /speicher|kapazit|batter|akku|energie|kwh|wh/],
        ['power', /leistung|ausgang|output|entlad|ladung|ladezeit|nennleistung|adapter|kw|watt/],
        ['pv', /\bpv\b|solar|modul|string|eingang|mpp|tracker|wp|strom/],
        ['backup', /notstrom|ersatzstrom|off.?grid|usv|umschalt|blackout|netz.?ausfall/],
        ['efficiency', /wirkungsgrad|effizienz|verlust|ertrag/],
        ['compatibility', /kompatib|anschluss|systemintegration|systemkomponente|betriebsspannung|plug.?and.?play|passend/],
        ['safety', /sicher|schutz|bms|afci|lichtbogen|ip\d/],
        ['control', /app|steuer|smart|meter|kommunikation|wlan|wifi|ethernet|rs485|monitor/],
        ['installation', /montage|halter|dach|wand|boden|kabel|leitung|schuko|stecker|länge/],
        ['temperature', /selbstheiz|heizung|temperatur|kälte|frost/],
        ['lifecycle', /garantie|zyklen|lebensdauer|lfp|lifepo|lithium.?eisenphosphat|batteriechemie/],
        ['bundle', /lieferumfang|set|anzahl|stück|enthalten|konfiguration/],
      ];
      const highlightCategories = (value) => new Set(
        highlightCategoryRules.filter(([, pattern]) => pattern.test(String(value || '').toLowerCase())).map(([name]) => name),
      );
      const setOverlap = (left, right) => [...left].filter((value) => right.has(value)).length;
      const isGenericHighlightDetail = (value) => {
        const detail = String(value || '').replace(/\s+/g, ' ').trim();
        return !detail
          || /^(produktinformation|allgemein|aufladezeit|daten|technische daten)$/i.test(detail)
          || /^[A-ZÄÖÜ][A-ZÄÖÜ\s/+-]{3,}$/u.test(detail)
          || /angebotenen/i.test(detail)
          || /bestandteil(?:e)? der gewählten konfiguration/i.test(detail)
          || /für pv-auslegung und systemabgleich/i.test(detail)
          || /^relevant für /i.test(detail);
      };
      const cleanHighlightDetail = (value, title = '') => {
        let detail = String(value || '')
          .replace(/\s+/g, ' ')
          .replace(/^\s*--\s*/, '')
          .trim();
        if (title) {
          const normalizedTitle = normalizeHighlightText(title);
          const normalizedStart = normalizeHighlightText(detail.slice(0, title.length + 8));
          if (normalizedStart.startsWith(normalizedTitle)) {
            detail = detail.slice(title.length).replace(/^\s*[:–—-]+\s*/, '').trim();
          }
        }
        return detail;
      };
      const highlightFallbackDetail = (stat) => {
        const source = `${stat?.label || ''} ${stat?.metric || ''}`;
        const categories = highlightCategories(source);
        if (categories.has('backup')) return 'für geeignete Verbraucher bei einem Netzausfall';
        if (categories.has('efficiency')) return 'für geringe Umwandlungsverluste';
        if (categories.has('lifecycle')) return 'für die langfristige Nutzung';
        if (categories.has('temperature')) return 'für den Betrieb bei niedrigen Temperaturen';
        if (categories.has('safety')) return 'für Schutz und zuverlässigen Betrieb';
        if (categories.has('capacity')) return 'legt die verfügbare Energiereserve fest';
        if (categories.has('compatibility')) return 'für die Kompatibilitätsprüfung vor dem Kauf';
        if (categories.has('pv')) return /strom|ampere|\ba\b/i.test(source)
          ? 'für den Abgleich mit den angeschlossenen PV-Strings'
          : 'für Modulbelegung und Anlagenauslegung';
        if (categories.has('installation')) return 'für die passende Anschluss- und Montageplanung';
        if (categories.has('control')) return 'für Steuerung und Verbrauchsübersicht';
        if (categories.has('bundle')) return 'gehört zur gewählten Set-Konfiguration';
        if (categories.has('power')) return 'für die Leistungsplanung passender Verbraucher';
        return '';
      };
      const highlightSourceScore = (stat, source) => {
        const statText = `${stat?.metric || ''} ${stat?.label || ''} ${stat?.note || ''}`;
        const sourceText = `${source?.title || ''} ${source?.body || ''}`;
        const categoryScore = setOverlap(highlightCategories(statText), highlightCategories(sourceText)) * 5;
        const measurementScore = setOverlap(highlightMeasurements(statText), highlightMeasurements(sourceText)) * 9;
        const tokenScore = Math.min(6, setOverlap(highlightTokens(statText), highlightTokens(sourceText)) * 1.5);
        return categoryScore + measurementScore + tokenScore;
      };
      const bestHighlightSentence = (stat, source) => {
        const statText = `${stat?.metric || ''} ${stat?.label || ''} ${stat?.note || ''}`;
        const statMeasurements = highlightMeasurements(statText);
        const sentences = cleanHighlightDetail(source?.body, source?.title)
          .split(/(?<=[.!?])\s+/)
          .map((sentence) => sentence.trim())
          .filter(Boolean);
        const safeSentences = sentences.filter((sentence) => {
          const extraMeasurements = [...highlightMeasurements(sentence)].filter((measurement) => !statMeasurements.has(measurement));
          const riskyClaim = /offiziell|autoris|zertifiz|garantie|bis zu\s*\d+\s*%\s*mehr|\bsuper\b|längste|dreimal/i.test(sentence);
          return extraMeasurements.length === 0 && !riskyClaim;
        });
        const statCategories = highlightCategories(statText);
        const ranked = safeSentences
          .map((sentence) => {
            const sentenceCategories = highlightCategories(sentence);
            const novelCategories = [...sentenceCategories].filter((category) => !statCategories.has(category)).length;
            return {
              sentence,
              score: setOverlap(statCategories, sentenceCategories) * 4
                + setOverlap(highlightTokens(statText), highlightTokens(sentence))
                + novelCategories * 3,
            };
          })
          .sort((left, right) => right.score - left.score);
        const selected = ranked[0]?.sentence || '';
        if (!selected || ranked[0].score < 2) return '';
        if (selected.length <= 118) return selected.replace(/[.!?]+$/, '');
        return '';
      };
      const highlightConceptKey = (value) => {
        const text = String(value || '').toLowerCase();
        if (/lifepo|lithium.?eisenphosphat|batteriechemie/.test(text)) return 'battery-chemistry';
        if (/speicherkapazit|nennenergie|\bkapazitat|\bkapazität/.test(text) || (/speicher/.test(text) && /\d+(?:[.,]\d+)?\s*(?:kwh|wh)/.test(text))) return 'storage-capacity';
        if (/zusatzakku|speichererweiter|erweiterungsakku/.test(text)) return 'storage-expansion';
        if (/pv.?modulset|pv.?setleistung|pv.?modulwahl|solarmodule?|modulanzahl|modulumfang/.test(text)) return 'pv-module-set';
        if (/gewicht|\d+(?:[.,]\d+)?\s*(?:kg|g)\b/.test(text)) return 'weight';
        if (/modulrahmen|rahmenhöhe/.test(text)) return 'frame-dimension';
        if (/abmess|dimension|maße|\d+\s*[×x]\s*\d+\s*[×x]\s*\d+\s*(?:mm|cm)/.test(text)) return 'dimensions';
        if (/material|aluminium|edelstahl/.test(text)) return 'material';
        if (/leiterquerschnitt|\d+(?:[.,]\d+)?\s*mm²/.test(text)) return 'conductor';
        if (/kabelwahl|kabeloption/.test(text)) return 'cable-choice';
        if (/längenwahl|kabellänge|leitungslänge/.test(text)) return 'cable-length';
        if (/mc4|stecker|offenes ende/.test(text)) return 'connector';
        if (/optimierer/.test(text) && /halter|montagebedarf/.test(text)) return 'optimizer-mounting';
        if (/mikrowechselrichter/.test(text) && /halter|montagebedarf/.test(text)) return 'microinverter-mounting';
        if (/kabel.*halter.*enthalten|halter.*kabel.*enthalten/.test(text)) return 'bundle-components';
        if (/schraub|befestigungsmaterial/.test(text)) return 'mounting-hardware';
        if (/neigung|ausrichtung|winkel/.test(text)) return 'mounting-angle';
        if (/pv.*eingang|eingangsleistung|pv.?gesamt|solareingang/.test(text)) return 'pv-input';
        if (/notstrom|ersatzstrom|off.?grid|usv|umschalt/.test(text)) return 'backup';
        if (/wirkungsgrad|effizienz/.test(text)) return 'efficiency';
        if (/smart.?meter|energiemess|verbrauchsgef/.test(text)) return 'energy-control';
        if (/kompatib|systemkomponente|betriebsspannung/.test(text)) return 'compatibility';
        if (/schutz|\bip\d|bms|afci/.test(text)) return 'safety';
        if (/selbstheiz|heizung|temperatur|kälte|frost/.test(text)) return 'temperature';
        if (/garantie|zyklen|lebensdauer/.test(text)) return 'lifecycle';
        if (/montage|halter|dach|wand|boden|kabel|leitung|schuko|stecker|länge/.test(text)) return 'installation';
        if (/ac.?ladeleistung|ladeleistung|nachladen/.test(text)) return 'charging-power';
        if (/ac.*leistung|netzausgang|ausgangsleistung|nennleistung/.test(text)) return 'output-power';
        if (/app|steuer|kommunikation|wlan|wifi|ethernet|rs485/.test(text)) return 'control';
        if (/lieferumfang|im set|enthalten|konfiguration/.test(text)) return 'bundle';
        return normalizeHighlightText(text).split(' ').slice(0, 3).join('-');
      };
      const isUsefulStandaloneHighlight = (source) => {
        const title = cleanHighlightDetail(source?.title);
        if (title.length < 8 || title.length > 92) return false;
        if (/^(mppt?|mpp tracker|produkt|produktinformation|wechselrichter|speicher|powerstation mini)$/i.test(title)) return false;
        if (/erhöhte erträge|perfekt|beste|super|weltweit|nummer\s*1|\b100\s*%|€|ersparnis|garantie|offiziell|autoris|zertifiz|installation in\s*\d|\d+\s*jahre|\d+\s*zyklen/i.test(title)) return false;
        if (highlightCategories(title).size === 0 && /anker|zendure|huawei|hoymiles|solax|deye|solarbank|solarflow/i.test(title)) return false;
        return highlightCategories(`${title} ${source?.body || ''}`).size > 0;
      };
      const standaloneHighlightScore = (source) => {
        const categories = highlightCategories(`${source?.title || ''} ${source?.body || ''}`);
        const priority = [
          ['backup', 95], ['compatibility', 90], ['safety', 85], ['control', 82], ['temperature', 80],
          ['installation', 76], ['lifecycle', 72], ['efficiency', 68], ['capacity', 64], ['power', 62],
          ['pv', 60], ['bundle', 55],
        ];
        return priority.find(([category]) => categories.has(category))?.[1] || 0;
      };
      const formatHighlightFact = (stat) => {
        const metric = String(stat?.metric || '').replace(/\s+/g, ' ').trim();
        const label = String(stat?.label || '').replace(/\s+/g, ' ').trim();
        if (!metric) return label;
        if (!label) return metric;
        const chemistryMetric = /lifepo|lithium.?eisenphosphat/i.test(metric);
        const metricFirst = !chemistryMetric && (/\d/.test(metric) || /^(?:bis|max\.?|ca\.?|über|unter)\b/i.test(metric));
        return metricFirst ? `${metric} ${label}` : `${label}: ${metric}`;
      };
      const renderHighlightFacts = (stats) => {
        if (!highlightFacts) return;
        const rawStats = Array.isArray(stats) ? stats.slice(0, 4) : [];
        const deferredStats = [];
        const seenConcepts = new Set();
        const selectedStats = [];
        rawStats.forEach((stat) => {
          const concept = highlightConceptKey(`${stat?.metric || ''} ${stat?.label || ''} ${stat?.note || ''}`);
          if (seenConcepts.has(concept)) {
            deferredStats.push(stat);
            return;
          }
          seenConcepts.add(concept);
          selectedStats.push(stat);
        });

        const usedSources = new Set();
        const points = selectedStats.map((stat) => {
          const statText = `${stat?.metric || ''} ${stat?.label || ''} ${stat?.note || ''}`;
          let bestIndex = -1;
          let bestScore = 0;
          highlightSources.forEach((source, index) => {
            if (usedSources.has(index)) return;
            const sourceText = `${source?.title || ''} ${source?.body || ''}`;
            const sharedMeasurements = setOverlap(highlightMeasurements(statText), highlightMeasurements(sourceText));
            const sharedTokens = setOverlap(highlightTokens(statText), highlightTokens(sourceText));
            const sharedCategories = setOverlap(highlightCategories(statText), highlightCategories(sourceText));
            if (sharedMeasurements === 0 && !(sharedTokens >= 2 && sharedCategories > 0)) return;
            const score = highlightSourceScore(stat, source);
            if (score > bestScore) {
              bestScore = score;
              bestIndex = index;
            }
          });
          let benefitDetail = '';
          if (bestIndex >= 0) {
            benefitDetail = bestHighlightSentence(stat, highlightSources[bestIndex]);
            if (benefitDetail) usedSources.add(bestIndex);
          }
          const note = cleanHighlightDetail(stat?.note);
          const detailParts = [];
          if (!isGenericHighlightDetail(note)) detailParts.push(note);
          if (benefitDetail && !normalizeHighlightText(detailParts.join(' ')).includes(normalizeHighlightText(benefitDetail))) {
            detailParts.push(benefitDetail);
          }
          if (detailParts.length === 0) {
            const fallback = highlightFallbackDetail(stat);
            if (fallback) detailParts.push(fallback);
          }
          return {
            fact: formatHighlightFact(stat),
            detail: detailParts.join(' · '),
          };
        }).filter((point) => point.fact);

        const standaloneSources = highlightSources
          .map((source, index) => ({ source, index, score: standaloneHighlightScore(source) }))
          .filter(({ source, index }) => !usedSources.has(index) && isUsefulStandaloneHighlight(source))
          .sort((left, right) => right.score - left.score);
        standaloneSources.forEach(({ source, index }) => {
          if (points.length >= 4) return;
          const title = cleanHighlightDetail(source.title);
          const concept = highlightConceptKey(`${title} ${source.body}`);
          if (seenConcepts.has(concept)) return;
          seenConcepts.add(concept);
          usedSources.add(index);
          points.push({ fact: title, detail: '' });
        });

        deferredStats.forEach((stat) => {
          if (points.length >= 4) return;
          const fact = formatHighlightFact(stat);
          if (!fact) return;
          const note = cleanHighlightDetail(stat?.note);
          points.push({
            fact,
            detail: isGenericHighlightDetail(note) ? highlightFallbackDetail(stat) : note,
          });
        });

        highlightFacts.replaceChildren();
        points.slice(0, 4).forEach((point) => {
          const item = document.createElement('li');
          const fact = document.createElement('strong');
          fact.textContent = point.fact;
          item.append(fact);
          if (point.detail) item.append(document.createTextNode(` – ${point.detail}`));
          highlightFacts.append(item);
        });
        highlightFacts.hidden = points.length === 0;
      };

      const renderKeyStats = (variant, selected) => {
        if (!statGrid) return;
        const variantStats = Array.isArray(variant?.key_stats) ? variant.key_stats : [];
        const fallbackStats = Array.isArray(productStatic.key_stats) ? productStatic.key_stats : [];
        const rawStats = variantStats.length ? variantStats : fallbackStats;
        const variantSpecifications = Array.isArray(variant?.specifications) ? variant.specifications : [];
        const fallbackSpecifications = Array.isArray(productStatic.specifications) ? productStatic.specifications : [];
        const rawSpecifications = variantSpecifications.length ? variantSpecifications : fallbackSpecifications;
        const pvModuleScopeMetric = rawStats.find((stat) => normalizeStatFingerprint(stat?.label) === 'pvmodulumfang')?.metric;
        const pvTotalMetric = rawStats.find((stat) => normalizeStatFingerprint(stat?.label) === 'pvgesamtleistung')?.metric;
        const hasDuplicatePvStats = pvModuleScopeMetric && pvTotalMetric
          && normalizeStatFingerprint(pvModuleScopeMetric) === normalizeStatFingerprint(pvTotalMetric);
        const selectedValues = Array.isArray(variant?.options) && variant.options.length
          ? variant.options
          : (Array.isArray(selected) ? selected : []);
        const variantSelections = (selectedValues.some(Boolean) ? selectedValues : String(variant?.title || '').split('/'))
          .map((value) => String(value || '').trim());
        const pvSelection = hasDuplicatePvStats ? parsePvModuleSelection(variant, selected) : null;
        const candidateStats = [
          ...rawStats.map((stat) => adaptPvSelectionStat(stat, pvSelection, variantSelections, hasDuplicatePvStats)),
          ...rawSpecifications.map((specification) => ({
            label: specification?.name,
            metric: specification?.value,
            note: specification?.note,
          })),
        ];
        const seenStatLabels = new Set();
        const seenStatMetrics = new Set();
        let stats = candidateStats
          .filter((stat) => stat?.metric && stat?.label && !isPhysicalKeyStat(stat))
          .filter((stat) => {
            const labelKey = normalizeStatFingerprint(stat.label);
            const metricKey = normalizeStatFingerprint(stat.metric);
            if (!labelKey || !metricKey || seenStatLabels.has(labelKey) || seenStatMetrics.has(metricKey)) return false;
            seenStatLabels.add(labelKey);
            seenStatMetrics.add(metricKey);
            return true;
          });
        if (stats.length === 0 && buybox.dataset.previewFixture === 'pro4_e5000') {
          const joined = selected.filter(Boolean).join(' | ');
          const capacity = joined.match(/(\d+)\s*kWh/i)?.[1] || '5';
          const moduleMatch = joined.match(/500\s*W?\s*[x×]\s*(\d+)/i) || joined.match(/(\d+)\s*[x×]\s*500\s*W/i);
          const moduleCount = moduleMatch?.[1] || '4';
          stats = [
            { metric: `${capacity} kWh`, label: 'gewählte Speicherkapazität' },
            { metric: '5.000 W', label: 'max. PV-Eingang' },
            { metric: '4 MPPT', label: 'unabhängige Tracker' },
            { metric: `${moduleCount} × 500 W`, label: 'gewählte Solarmodule' },
          ];
        }
        if (stats.length === 0) {
          statGrid.replaceChildren();
          statGrid.hidden = true;
          const details = root.querySelector('[data-mp-stat-details]');
          if (details) details.hidden = true;
          renderHighlightFacts([]);
          return;
        }
        statGrid.replaceChildren();
        statGrid.hidden = false;
        stats.slice(0, 3).forEach((stat) => {
          const card = document.createElement('div');
          card.className = 'mp-stat-card';
          const term = document.createElement('dt');
          term.textContent = stat.label;
          const value = document.createElement('dd');
          value.textContent = stat.metric;
          card.append(term, value);
          if (stat.note) {
            const note = document.createElement('dd');
            note.className = 'mp-stat-note';
            note.textContent = stat.note;
            card.append(note);
          }
          statGrid.append(card);
        });
        const details = root.querySelector('[data-mp-stat-details]');
        const detailList = root.querySelector('[data-mp-stat-detail-list]');
        if (details && detailList) {
          detailList.replaceChildren();
          stats.slice(0, 4).forEach((stat) => {
            const item = document.createElement('li');
            const heading = document.createElement('strong');
            heading.textContent = `${stat.metric} · ${stat.label}`;
            item.append(heading);
            if (stat.note) {
              const note = document.createElement('span');
              note.textContent = stat.note;
              item.append(note);
            }
            detailList.append(item);
          });
          details.hidden = !stats.length;
        }
        renderHighlightFacts(stats.slice(0, 4));
      };

      const parseDisplayedMoney = (value) => {
        const compact = String(value || '').replace(/[^0-9,.-]/g, '');
        if (!compact) return null;
        const comma = compact.lastIndexOf(',');
        const dot = compact.lastIndexOf('.');
        const separator = Math.max(comma, dot);
        const decimals = separator >= 0 && compact.length - separator - 1 === 2 ? separator : -1;
        const normalized = decimals >= 0
          ? `${compact.slice(0, decimals).replace(/[.,]/g, '')}.${compact.slice(decimals + 1)}`
          : compact.replace(/[.,]/g, '');
        const amount = Number(normalized);
        return Number.isFinite(amount) ? Math.round(amount * 100) : null;
      };

      const syncDisplayedSaving = () => {
        const price = root.querySelector('[data-mp-price]');
        const compare = root.querySelector('[data-mp-compare]');
        const saving = root.querySelector('[data-mp-saving]');
        const saleKicker = root.querySelector('[data-mp-sale-kicker]');
        if (!price || !compare || !saving || buybox.dataset.mpVariantAvailability === 'unavailable' || compare.hidden) {
          if (saving) saving.hidden = true;
          if (saleKicker) saleKicker.hidden = true;
          return;
        }
        const priceCents = parseDisplayedMoney(price.textContent);
        const compareCents = parseDisplayedMoney(compare.textContent);
        const difference = priceCents == null || compareCents == null ? null : compareCents - priceCents;
        if (!(difference > 0)) {
          saving.hidden = true;
          if (saleKicker) saleKicker.hidden = true;
          return;
        }
        const percentage = Math.max(1, Math.round((difference / compareCents) * 100));
        const amount = document.createElement('span');
        amount.className = 'mp-price__saving-amount';
        amount.textContent = saving.dataset.template.replace('__AMOUNT__', money(difference, buybox.dataset.currency || 'EUR'));
        const percent = document.createElement('span');
        percent.className = 'mp-price__saving-percent';
        percent.textContent = saving.dataset.percentTemplate.replace('__PERCENT__', String(percentage));
        const mobileAmount = document.createElement('span');
        mobileAmount.className = 'mp-price__saving-mobile';
        mobileAmount.textContent = '−' + money(difference, buybox.dataset.currency || 'EUR');
        saving.replaceChildren(amount, mobileAmount, percent);
        saving.hidden = false;
        if (saleKicker) saleKicker.hidden = false;
      };

      const observedPrice = root.querySelector('[data-mp-price]');
      const observedCompare = root.querySelector('[data-mp-compare]');
      if (observedPrice && observedCompare) {
        const priceObserver = new MutationObserver(() => { syncDisplayedSaving(); updateOptionPrices(); });
        priceObserver.observe(observedPrice, { childList: true, characterData: true, subtree: true });
        priceObserver.observe(observedCompare, { attributes: true, attributeFilter: ['hidden'], childList: true, characterData: true, subtree: true });
      }

      const renderStockMeter = (variant) => {
        const meter = root.querySelector('[data-mp-stock-meter]');
        if (!meter) return;
        const threshold = Number(meter.dataset.stockThreshold) || 300;
        const quantity = Number(variant?.inventory_quantity);
        const shouldShow = Boolean(
          variant?.available
          && buybox.dataset.mpEmailOnly !== 'true'
          && resolveShipping(variant).mode !== 'preorder'
          && variant.inventory_management
          && variant.inventory_policy === 'deny'
          && Number.isFinite(quantity)
          && quantity > 0
          && quantity <= threshold
        );
        meter.hidden = !shouldShow;
        if (!shouldShow) return;
        const label = meter.querySelector('[data-mp-stock-label]');
        const track = meter.querySelector('[data-mp-stock-track]');
        const fill = meter.querySelector('[data-mp-stock-fill]');
        const text = buybox.dataset.inventoryRemainingTemplate.replace('__QUANTITY__', String(quantity));
        const percentage = Math.max(0, Math.min(100, Math.round((quantity / threshold) * 100)));
        if (label) label.textContent = text;
        if (track) {
          track.setAttribute('aria-valuemax', String(threshold));
          track.setAttribute('aria-valuenow', String(quantity));
          track.setAttribute('aria-valuetext', text);
        }
        if (fill) fill.style.width = `${percentage}%`;
      };

      const update = () => {
        const addButtons = getAddButtons();
        const selected = [...root.querySelectorAll('[data-mp-option-position]')].map((group) => {
          return group.querySelector('input:checked')?.value;
        });
        updateOptionStates(selected);
        updateOptionPrices();
        let variant = variantState.findVariant(variants, selected);
        if (selected.length === 0) variant = variants[0];
        const prelaunchLabel = buybox.dataset.mpEmailOnly === 'true' || String(variant?.id) === buybox.dataset.prelaunchVariantId
          ? buybox.dataset.prelaunchLabel || ''
          : '';

        root.dataset.mpPreorderPending = 'false';
        const availability = root.querySelector('[data-mp-availability]');
        const priceWrapper = root.querySelector('[data-product-price]');
        const purchaseState = updatePurchaseControls(variant);
        const gallerySaleBadges = root.querySelectorAll('[data-mp-gallery-sale-badge]');
        if (gallerySaleBadges.length) {
          const price = Number(variant?.price);
          const compareAt = Number(variant?.compare_at_price);
          const percent = compareAt > price && price >= 0
            ? Math.round((compareAt - price) * 100 / compareAt)
            : 0;
          gallerySaleBadges.forEach((gallerySaleBadge) => {
            gallerySaleBadge.hidden = percent <= 0;
            const discount = gallerySaleBadge.dataset.discountTemplate.replace('__percent__', String(percent));
            gallerySaleBadge.querySelector('strong').textContent = discount;
            gallerySaleBadge.setAttribute('aria-label', gallerySaleBadge.dataset.saleLabel + ': ' + discount);
          });
        }
        activeVariant = variant || null;
        activePurchaseAvailability = purchaseState.availability;
        renderStockMeter(variant);
        renderPickupAvailability(variant);
        renderVariantBom(variant, selected);
        renderKeyStats(variant, selected);
        if (!variant) {
          renderShippingContext(null, purchaseState.availability);
          renderInterestForm(null);
          addButtons.forEach((button) => {
            const label = button.querySelector('[data-mp-add-label]');
            if (label) label.textContent = buybox.dataset.unavailableLabel;
          });
          const compare = root.querySelector('[data-mp-compare]');
          const saving = root.querySelector('[data-mp-saving]');
          const skuWrap = root.querySelector('[data-mp-sku-wrap]');
          if (compare) compare.hidden = true;
          if (saving) saving.hidden = true;
          if (priceWrapper) priceWrapper.classList.remove('is-from');
          if (skuWrap) skuWrap.hidden = true;
          if (priceWrapper) priceWrapper.hidden = true;
          const summarySku = root.querySelector('[data-mp-summary-sku]');
          const summaryAvailability = root.querySelector('[data-mp-summary-availability]');
          const summaryOptions = root.querySelector('[data-mp-selected-options]');
          const summaryPrice = root.querySelector('[data-mp-summary-price]');
          const summaryCompare = root.querySelector('[data-mp-summary-compare]');
          if (summarySku) summarySku.textContent = '–';
          if (summaryAvailability) summaryAvailability.textContent = buybox.dataset.unavailableLabel;
          if (summaryOptions) summaryOptions.textContent = selected.filter(Boolean).join(' · ');
          if (summaryPrice) summaryPrice.textContent = '–';
          if (summaryCompare) summaryCompare.hidden = true;
          if (availability) {
            availability.innerHTML = '';
            const status = document.createElement('span');
            status.className = 'mp-status mp-status--unavailable';
            status.textContent = buybox.dataset.unavailableLabel;
            availability.append(status);
            availability.hidden = false;
          }
          notifyVariantInputs();
          const url = new URL(window.location.href);
          url.searchParams.delete('variant');
          window.history.replaceState({}, '', url);
          return;
        }

        const price = root.querySelector('[data-mp-price]');
        const compare = root.querySelector('[data-mp-compare]');
        const saving = root.querySelector('[data-mp-saving]');
        const payLater = root.querySelector('#paypal-upstream-messaging-product');
        const sku = root.querySelector('[data-mp-sku]');
        const skuWrap = root.querySelector('[data-mp-sku-wrap]');
        const currency = buybox.dataset.currency || 'EUR';

        if (priceWrapper) priceWrapper.hidden = false;
        if (price) price.textContent = money(variant.price, currency);
        if (payLater) payLater.setAttribute('data-pp-amount', (Number(variant.price) / 100).toFixed(2));
        if (priceWrapper) priceWrapper.classList.toggle('is-from', buybox.dataset.initialPriceMode === 'from' && !optionSelectionChanged);
        const onSale = Number(variant.compare_at_price) > Number(variant.price);
        if (compare) {
          compare.hidden = !onSale;
          compare.textContent = onSale ? money(variant.compare_at_price, currency) : '';
        }
        if (saving) {
          saving.hidden = !onSale;
          if (!onSale) saving.replaceChildren();
        }
        syncDisplayedSaving();

        if (sku && skuWrap) {
          sku.textContent = variant.sku || '';
          skuWrap.hidden = !variant.sku;
        }

        const summarySku = root.querySelector('[data-mp-summary-sku]');
        const summaryAvailability = root.querySelector('[data-mp-summary-availability]');
        const summaryOptions = root.querySelector('[data-mp-selected-options]');
        const summaryPrice = root.querySelector('[data-mp-summary-price]');
        const summaryCompare = root.querySelector('[data-mp-summary-compare]');
        if (summarySku) summarySku.textContent = variant.sku || '–';
        if (summaryAvailability) {
          summaryAvailability.textContent = variant.available ? buybox.dataset.availableLabel : prelaunchLabel || buybox.dataset.soldoutLabel;
          summaryAvailability.style.color = variant.available ? 'var(--mp-success)' : prelaunchLabel ? 'var(--mp-blue)' : 'var(--mp-danger)';
        }
        if (summaryOptions) summaryOptions.textContent = variant.options.filter(Boolean).join(' · ');
        if (summaryPrice) summaryPrice.textContent = money(variant.price, currency);
        if (summaryCompare) {
          summaryCompare.hidden = !onSale;
          summaryCompare.textContent = onSale ? money(variant.compare_at_price, currency) : '';
        }
        root.mpSyncMediaStickyStage?.();

        const quantityRule = variant.quantity_rule || { min: 1, max: null, increment: 1 };
        getQuantityInputs().forEach((input) => {
          const minimum = Number(quantityRule.min) || 1;
          const increment = Number(quantityRule.increment) || 1;
          const maximum = quantityRule.max == null ? null : Number(quantityRule.max);
          input.min = String(minimum);
          input.step = String(increment);
          if (maximum == null || !Number.isFinite(maximum)) input.removeAttribute('max');
          else input.max = String(maximum);
          let nextValue = Number(input.value);
          if (!Number.isFinite(nextValue) || nextValue < minimum) nextValue = minimum;
          nextValue = minimum + Math.ceil((nextValue - minimum) / increment) * increment;
          if (maximum != null && Number.isFinite(maximum)) nextValue = Math.min(nextValue, maximum);
          input.value = String(nextValue);
        });
        syncQuantityButtons();
        renderShippingContext(variant, purchaseState.availability);
        renderInterestForm(variant);

        const selectedShipping = resolveShipping(variant);
        // Presentation only: purchase controls remain governed by purchaseState.
        root.dataset.mpPreorderPending = String(!purchaseState.formSubmittable && Boolean(
          prelaunchLabel || (selectedShipping.status === 'ok' && selectedShipping.mode === 'preorder')
        ));
        addButtons.forEach((button) => {
          const label = button.querySelector('[data-mp-add-label]');
          if (!label) return;
          if (buybox.dataset.mpEmailOnly === 'true') {
            label.textContent = prelaunchLabel;
          } else if (variant.available) {
            label.textContent = buybox.dataset.addLabel;
          } else if (prelaunchLabel) {
            label.textContent = prelaunchLabel;
          } else if (selectedShipping.status === 'ok' && selectedShipping.mode === 'preorder') {
            label.textContent = selectedShipping.availableFrom
              ? `${buybox.dataset.preorderAvailableLabel} ${formatShippingDate(selectedShipping.availableFrom)}`
              : buybox.dataset.shippingPreorderPendingTemplate;
          } else {
            label.textContent = buybox.dataset.soldoutLabel;
          }
        });

        if (availability) {
          availability.innerHTML = '';
          if (purchaseState.availability === 'available' || selectedShipping.mode === 'preorder' || prelaunchLabel) {
            availability.hidden = true;
          } else {
            const status = document.createElement('span');
            status.className = 'mp-status mp-status--soldout';
            status.textContent = buybox.dataset.soldoutLabel;
            availability.append(status);
            availability.hidden = false;
          }
        }

        const optionMediaId = resolveOptionMedia(root, selected);
        const selectedMediaId = variant.featured_media?.id || optionMediaId;
        if (selectedMediaId) selectMedia(root, selectedMediaId);
        const activeMedia = root.querySelector('[data-mp-media-id]:not([hidden])');
        const activeImage = activeMedia?.querySelector('img');
        document.dispatchEvent(new CustomEvent('mp:product-variant-change', {
          detail: {
            productId: String(root.dataset.mpProductId || ''),
            variant,
            options: selected.filter(Boolean),
            media: activeImage ? {
              id: activeMedia.dataset.mpMediaId,
              src: activeImage.currentSrc || activeImage.src,
              alt: activeImage.alt || '',
            } : null,
          },
        }));
        notifyVariantInputs();
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };

      root.querySelectorAll('[data-mp-option-position] input').forEach((input) => {
        input.addEventListener('change', () => {
          optionSelectionChanged = true;
          update();
        });
      });

      update();

      document.addEventListener('mp:tax-role-changed', updateOptionPrices);
      document.addEventListener('mp:tax-content-ready', updateOptionPrices);
      root.mpProductUpdate = update;
    };
    const initRoots = (scope = document) => {
      if (scope.matches?.('[data-mp-product-root]')) initRoot(scope);
      scope.querySelectorAll?.('[data-mp-product-root]').forEach(initRoot);
    };
    initRoots();
    document.addEventListener('shopify:section:load', (event) => {
      initRoots(event.target);
      document.querySelectorAll('[data-mp-product-root]').forEach((root) => root.mpProductUpdate?.());
    });
    document.addEventListener('mp:variant-state-ready', () => initRoots());
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();


/* Enhance the existing sections only on phones; preserve desktop DOM and state. */
(() => {
  const initMobileProductPresentation = () => {
    if (!document.body.classList.contains('template-product')) return;
    const phone = window.matchMedia('(max-width: 749px)');
    const states = new Map();
    let nextPanelId = 0;
    const applyState = (section, state) => {
      if (!phone.matches) {
        if (!state.button) return;
        state.heading.replaceChildren(...state.titleNodes);
        state.panel.hidden = state.originalHidden;
        state.descriptions.forEach(({ node, hidden }) => { node.hidden = hidden; });
        if (!state.originalId) state.panel.removeAttribute('id');
        delete section.dataset.mpMobileDisclosure;
        delete section.dataset.mpMobileExpanded;
        state.button = null;
        return;
      }
      if (!state.button) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mp-mobile-disclosure-toggle';
        button.textContent = section.matches('.mp-specs')
          ? section.querySelector('.mp-eyebrow')?.textContent.trim() || state.heading.textContent.trim()
          : state.heading.textContent.trim();
        state.panel.id = state.originalId || `mp-mobile-product-panel-${++nextPanelId}`;
        button.setAttribute('aria-controls', state.panel.id);
        button.addEventListener('click', () => {
          state.expanded = !state.expanded;
          applyState(section, state);
        });
        state.heading.replaceChildren(button);
        state.button = button;
        section.dataset.mpMobileDisclosure = 'true';
      }
      state.button.setAttribute('aria-expanded', String(state.expanded));
      section.dataset.mpMobileExpanded = String(state.expanded);
      state.panel.hidden = !state.expanded;
      state.descriptions.forEach(({ node, hidden }) => { node.hidden = hidden || !state.expanded; });
    };
    const scan = () => {
      if (document.querySelector('[data-mp-mobile-detail-nav]')) return;
      for (const section of states.keys()) if (!section.isConnected) states.delete(section);
      document.querySelectorAll('.mp-product-content .mp-manuals').forEach((section) => {
        if (!states.has(section)) {
          const heading = section.querySelector('h2');
          const panel = section.querySelector('.mp-downloads, .mp-specifications');
          if (!heading || !panel) return;
          const descriptions = [...section.querySelectorAll('.mp-manuals__intro > p:not(.mp-eyebrow)')]
            .map(node => ({ node, hidden: node.hidden }));
          states.set(section, { heading, panel, descriptions, titleNodes: [...heading.childNodes],
            originalHidden: panel.hidden, originalId: panel.id, expanded: false, button: null });
        }
        applyState(section, states.get(section));
      });
    };
    const cart = document.querySelector('[data-mp-native-sticky-cart]');
    const syncCartHeight = () => {
      if (!phone.matches) {
        document.body.style.removeProperty('--mp-mobile-cart-height');
        return;
      }
      if (!cart) return;
      const height = `${Math.ceil(cart.getBoundingClientRect().height)}px`;
      if (document.body.style.getPropertyValue('--mp-mobile-cart-height') !== height) {
        document.body.style.setProperty('--mp-mobile-cart-height', height);
      }
    };
    if (cart && 'ResizeObserver' in window) new ResizeObserver(syncCartHeight).observe(cart);
    phone.addEventListener('change', () => { scan(); syncCartHeight(); });
    document.addEventListener('shopify:section:load', scan);
    scan();
    syncCartHeight();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initMobileProductPresentation, { once: true });
  else initMobileProductPresentation();
})();



